import React from "react";
import classNames from "classnames";
import "./Loading.scss";
// may eventually contain some sort of loading spinner... for now, just an empty div

function Loading({ minHeightDesktop }) {
  return (
    <div
      className={classNames("", {
        "Loading-minHeightDesktop": minHeightDesktop,
      })}
    />
  );
}

export default Loading;
